import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import makeAnimated from 'react-select/animated';
import { addState } from 'slices/stateSlice';
import { updateState } from 'slices/stateSlice';
import { fetchStates } from 'slices/stateSlice';
import { fetchTimezone } from "slices/timezoneSlice";
import toast from 'react-hot-toast';
import { stateSelector } from 'slices/stateSlice';
import { setError } from 'slices/stateSlice';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { useTranslation } from 'react-i18next';

const AddStateForm = ({ item, handleClose, callback, statusPerm }) => {

  const { t } = useTranslation();
  const animatedComponents = makeAnimated();
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({
    name: '',
    timezone_id: '',
    status: 1,
  })
  const [timezoneOptions, setTimezoneOptions] = useState([]);
  const [selectedTimezone, setSelectedTimezone] = useState(null);
  const { error, loader } = useSelector(stateSelector);

console.log('item',item)
  useEffect(() => {

    if (item?.id)
      setFormValues({
        name: item?.name || "",
        timezone_id: item?.timezone?.id || "",
        status: item?.status
      })
      setSelectedTimezone({
        value: item?.timezone?.id || '',
        label: item?.timezone?.display_name || ''
      });

    dispatch(setError({}))
    return () => {

      setFormValues({
        ...formValues,
        name: "",
        status: 1
      });
      // Clean up on unmount
      // This is where you would dispatch an action to remove the hospital from the store
    }

  }, [item])

 

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  }

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchStates())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission
    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateState(formValues, item?.id, submitCallback));
    } else
      dispatch(addState(formValues, submitCallback));

  }


  const handleTimezoneChange = (selected) => {
    setSelectedTimezone(selected);
    setFormValues({ ...formValues, timezone_id: selected?.value || '' });
  };
  
  const filteredTimezonesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(
      fetchTimezone(
        page,
        {
          pageLength: 10,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.display_name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  console.log("error", error)

  return (
    <div>
      <form onSubmit={handleSubmit}>


        <div className="row-primary">
          <h2>{t('stateForm.nameLabel')}</h2>
          <input onChange={handleChange}
            required name="name"
            className="input-in type_inp"
            type="text"
            placeholder={t('stateForm.namePlaceholder')}
            value={formValues.name}
          />
        </div>

                   {/* <div className="row-primary">
                            <h2>Timezone</h2>
                            <Controller
                    name="timezone_id"
                    control={control}
                    rules={{ required: "Please select a Timezone" }}
                    render={({ field }) => (
                      <div style={{ width: "100%" }}>
                        <AsyncPaginate
                          styles={selectCustomStyles}
                          value={selectedTimezone}
                          loadOptions={filteredTimezonesLoadOptions}
                          isClearable
                          placeholder="Select Timezone"
                          onChange={(selected) => {
                            setSelectedTimezone(selected);
                            setValue("timezone_id", selected?.value || "");
                            field.onChange(selected?.value || "");
                          }}
                          additional={{ page: 1 }}
                        />
                        {errors?.timezone_id?.message && (
                          <div style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errors?.timezone_id?.message} />
                          </div>
                        )}
                      </div>
                    )}
                  />
                  
                          </div> */}


                           <div className="row-primary">
            <h2>{t('stateForm.timezoneLabel')}</h2>
            <AsyncPaginate
              styles={selectCustomStyles}
              value={selectedTimezone}
              loadOptions={filteredTimezonesLoadOptions}
              onChange={handleTimezoneChange}
              isClearable
              placeholder={t('stateForm.timezonePlaceholder')}
              additional={{ page: 1 }}
            />
          </div>


                          
        {statusPerm &&
          <div className="row-primary template_switch" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>{t('table.status')}</h2>
            <CustomSwitch
              labelText="active"
              checked={formValues.status == 1 ? true : false}
              handleChange={(checked) => setFormValues({
                ...formValues,
                status: checked ? 1 : 0
              })}

            />
          </div>
        }

        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" onClick={handleClose}>{t('common.cancel')}</button>
          <SubmitButton
            btnText={item?.id ? t('common.update') : t('common.create')}
            loader={loader}
          />
        </div>
      </form >

    </div >
  )
}

const AddState = ({ item, show, onClose, callback, statusPerm }) => {
  const { t } = useTranslation();
  console.log(show, "show");
  if (!show) return null;
  return (
    <>
    <div className={`modal fade show`} style={{ display: 'block' }} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? t('common.update') : t('common.create')} {t('stateForm.title')}</h5>
            <button onClick={onClose} type="button" className="btn-close" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddStateForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
    </>
  )
}

export default AddState
